const PermissionModel: Model = {
  name: 'permissions',
  title: 'Permission',
  description: 'Permissions',
  fields: [],
};

export default PermissionModel;
